import { toast } from "sonner";

export function getShareUrl(videoId) {
  return `${window.location.origin}/watch/${videoId}`;
}

// Shares an arbitrary external URL (e.g. an Instagram reel) via the native
// share sheet, falling back to clipboard copy.
export async function shareExternal(url, title) {
  const text = title ? `Watch "${title}" on QTV Network` : "Watch on QTV Network";
  if (navigator.share) {
    try {
      await navigator.share({ title: text, text, url });
      return;
    } catch (e) {
      if (e && e.name === "AbortError") return;
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copied — share it with a friend!");
  } catch (e) {
    toast.error("Couldn't copy the link");
  }
}

// Uses the native share sheet when available (mobile), otherwise copies the
// link to the clipboard and confirms with a toast.
export async function shareVideo(video) {
  const url = getShareUrl(video.id);
  const title = video?.title ? `Watch "${video.title}" on QTV Network` : "Watch on QTV Network";

  if (navigator.share) {
    try {
      await navigator.share({ title, text: title, url });
      return;
    } catch (e) {
      if (e && e.name === "AbortError") return;
    }
  }

  try {
    await navigator.clipboard.writeText(url);
    toast.success("Link copied — share it with a friend!");
  } catch (e) {
    const ta = document.createElement("textarea");
    ta.value = url;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
      toast.success("Link copied — share it with a friend!");
    } catch (err) {
      toast.error("Couldn't copy the link");
    }
    document.body.removeChild(ta);
  }
}
